export default __webpack_public_path__ + "static/media/1-pollution.d1729545.png";